import { BY_ID } from '../state/structures';

export function HoverLabel({ id, x, y }: { id: string; x: number; y: number }) {
  const s = BY_ID.get(id);
  if (!s) return null;
  return (
    <div class="hover-label" style={{ left: `${x + 14}px`, top: `${y + 10}px` }} role="tooltip" data-testid="hover-label">
      {s.title}
    </div>
  );
}
